import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { api } from "@/lib/api";
import { formatEuros } from "@/lib/format";
import { FicheCarte } from "@/components/FicheCarte";

export const Entonnoir = ({ stats }) => {
  const [ouverte, setOuverte] = useState(null);
  const [fiches, setFiches] = useState([]);
  if (!stats) return null;
  const max = Math.max(1, ...stats.etapes.map((e) => e.nombre));
  const ouvrir = (e) => { setOuverte(e); setFiches([]); api.get("/fiches", { params: { processus_id: stats.processus.id, etape: e.code } }).then((r) => setFiches(r.data)); };
  return (
    <section className="space-y-1" data-testid="view-entonnoir">
      {stats.etapes.map((e, i) => (
        <div key={e.code}>
          <button type="button" onClick={() => ouvrir(e)} className="w-full text-left min-h-[44px] flex flex-col items-center group" data-testid={`funnel-bar-${e.code}`}>
            <span className="h-11 at-pill flex items-center justify-center px-3 transition-transform duration-200 group-hover:scale-[1.02] min-w-[96px]"
              style={{ width: `${Math.max(28, (e.nombre / max) * 100)}%`, background: e.temperature || "var(--muted)", color: "var(--accent-ink)" }}>
              <span className="text-sm font-bold truncate" data-testid={`funnel-count-${e.code}`}>{e.nombre}</span>
            </span>
            <span className="text-xs font-semibold mt-1 truncate max-w-full">{e.nom} · {formatEuros(e.montant)}</span>
          </button>
          {i < stats.etapes.length - 1 && (
            <p className="text-center text-xs at-muted py-1" data-testid={`funnel-loss-${e.code}`}>
              {e.passage_suivant === null ? "—" : `Perte ${100 - e.passage_suivant} %`}
            </p>
          )}
        </div>
      ))}
      <p className="text-center text-sm at-muted pt-3" data-testid="funnel-lost">Perdues : {stats.perdus.nombre}</p>
      <Sheet open={Boolean(ouverte)} onOpenChange={(o) => !o && setOuverte(null)}>
        <SheetContent side="bottom" className="at-popover max-h-[85vh] overflow-y-auto" data-testid="funnel-sheet">
          <SheetHeader><SheetTitle>{ouverte?.nom}</SheetTitle><SheetDescription className="at-muted">{fiches.length} fiche(s)</SheetDescription></SheetHeader>
          <div className="grid md:grid-cols-2 gap-2 mt-4">{fiches.map((f) => <FicheCarte key={f.id} fiche={f} />)}</div>
        </SheetContent>
      </Sheet>
    </section>
  );
};
